import type { ListCard } from './types';
import ListCardMosaic from './ListCardMosaic';

type ListCardGridProps = {
    lists: ListCard[];
    onOpenList: (id: string) => void;
};

export default function ListCardGrid({ lists, onOpenList }: ListCardGridProps) {
    return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
            {lists.map((list) => (
                <ListCardMosaic key={list.id} list={list} onOpen={() => onOpenList(list.id)} />
            ))}
        </div>
    );
}
